/**
 * The pie panel type and the settings it draws from.
 */

const pie = {
  names: [{ id: 'pie', label: 'Pie chart', phrase: 'a pie chart', guide: 'pie.md', advanced: true, toolSummary: 'parts of one whole — one row per positive slice, capped at eight', promptSummary: 'how one whole divides into a few parts — one row per positive slice, up to eight' }],
  block: 'pie',
  /* AnalyticsPiePanel fires sliceClick with the slice's SOURCE ROW — every field the row carries,
     not just the drawn label/value — so same-named binding reaches ids the pie never displays. */
  events: ['sliceClick'],
  /* Pie. The query already returns one row per part; this block only identifies its label and
     positive numeric value. */
  fields: {
    labelKey: { kind: 'string', required: true, label: 'Slice label' },
    valueKey: { kind: 'string', required: true, label: 'Slice value' }
  },
  editorHint: 'One row is one slice. Aggregate and order the parts in SQL, and keep the result to the eight categories that matter most.',
  stateSummary: ({ block }) => (block.labelKey && block.valueKey ? `pie: ${block.labelKey} × ${block.valueKey}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['labelKey', 'valueKey'],
    description: 'Pie mapping (displayType "pie"): ONE ROW IS ONE SLICE of a meaningful whole. Aggregate, order largest-first, and LIMIT 8 in the source SQL; the renderer also enforces eight and reports anything it cannot draw. Read immutable/analytics/panel-types/pie.md before configuring one.',
    properties: {
      labelKey: { type: 'string', description: 'Column naming the slice. Dot paths work.' },
      valueKey: { type: 'string', description: 'Column holding the positive numeric slice value. Dot paths work.' }
    }
  }
};

export default pie;
